import React, { useState } from 'react';
import { DashboardLayout } from '../components/Dashboard';
import { useParams, useNavigate } from "react-router-dom";
import { updateStatusApi } from '../api/services-third-parties';
import { useSelector } from 'react-redux';
import { ValidAccessToken } from '../core/function/function-generic';

interface State {
    status: string;
    refPayment: string;
    error: boolean;
}

export const Edit = () => {
    ValidAccessToken();
    const navigate = useNavigate();
    let { id } = useParams();
    const [state, setState] = useState<State>({
        status: 'completed',
        refPayment: '',
        error: false
    });
    const stateSelect = useSelector((params: any) => params.business);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        setState((prevProps) => ({
            ...prevProps,
            [event.target.name]: event.target.value
        }));
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        try {
            event.preventDefault();
            const params: any = {
                id: id,
                status: state.status === 'completed' ? true : false,
                refPayment: state.refPayment,
                business: stateSelect.id
            };
            const { status } = await updateStatusApi(params);
            if (status === 200) {
                navigate('/withdrawal');
            }
        } catch (err) {
            setState((prevProps) => ({
                ...prevProps,
                error: true
            }));
        }
    };

    return (
        <DashboardLayout pageTitle="Edit withdrawal">
            <div className='flex justify-center align-center'>
                <div className="w-full max-w-xs">
                    <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" onSubmit={handleSubmit}>
                        {state.error &&
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                                <span className="block sm:inline">invalid.</span>
                            </div>
                        }
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Status
                            </label>
                            <div className="relative">
                                <select onChange={handleChange} value={state.status} name='status' className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                                    <option value='completed'>Completed</option>
                                    <option value='rejected'>Rejected</option>
                                </select>
                            </div>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" >
                                Description
                            </label>
                            <input onChange={handleChange} value={state.refPayment} name='refPayment' required className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="description" type="text" placeholder="Description" />
                        </div>
                        <div className="flex items-center justify-between">
                            <button type="submit" className="bg-primary text-white text-center w-60 p-4 border rounded-full">Send</button>
                        </div>
                    </form>
                </div>
            </div>
        </DashboardLayout>
    );
};